function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 48 41"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M21.69 0a2.1 2.1 0 010 4.2H6c-1.26 0-1.8.86-1.8 1.26v29.57c0 .45.5 1.26 1.8 1.26H21.7a2.1 2.1 0 010 4.2H6c-3.04 0-6-2.15-6-5.46H0V5.46C0 2.2 2.92 0 6.01 0H21.7zm13.33 5.83l10.23 10.43.01.02 1.93 1.95a2.87 2.87 0 010 4.02l-1.92 1.95-.02.02-4.72 4.81-1.77 1.8-3.74 3.82c-2.16 2.2-3.9 1.48-3.9-1.6v-6.4H16.2a2.71 2.71 0 01-2.71-2.7v-7.4c0-1.5 1.21-2.71 2.7-2.71h14.92V7.42c0-3.07 1.76-3.78 3.9-1.6z",
  fillRule: "nonzero"
})));